import React, { useEffect, useState } from 'react';
import pt from 'prop-types';

import { BaseDialog } from '@metarouter-private/mr-mui';

import CommitMessageModalContent from './CommitMessageModalContent';
import CommitMessageModalActions from './CommitMessageModalActions';

const DIALOG_PROPS = { maxWidth: 'sm', fullWidth: true };

export default function CommitMessageModal({ open, onClose, onSave, loading }) {
  const [commitMessage, setCommitMessage] = useState('');

  useEffect(() => {
    if (!open) setCommitMessage('');
  }, [open]);

  const handleSave = () => {
    onSave(commitMessage.trim() || null);
  };

  return (
    <BaseDialog
      DialogProps={{ ...DIALOG_PROPS, open, onClose }}
      title="Save as New Revision"
      content={<CommitMessageModalContent commitMessage={commitMessage} onChange={setCommitMessage} />}
      actions={<CommitMessageModalActions onCancel={onClose} onSave={handleSave} loading={loading} />}
    />
  );
}

CommitMessageModal.propTypes = {
  open: pt.bool.isRequired,
  onClose: pt.func.isRequired,
  onSave: pt.func.isRequired,
  loading: pt.bool,
};
